import appConst from "../Utilities/appConst.json";

export const discountTypesMap = new Map();
discountTypesMap.set(0, "₪"); //fix
discountTypesMap.set(1, "%"); // prcent
discountTypesMap.set(2, "₪"); // flat

export const couponTermsMap = new Map();
couponTermsMap.set(0, appConst.CAN_NOT_DOUBLE_DISCOUNTS);
couponTermsMap.set(1, appConst.CAN_NOT_DOUBLE_DISCOUNTS);
couponTermsMap.set(2, appConst.CAN_NOT_DOUBLE_DISCOUNTS);

export const colorMap = new Map();
colorMap.set(0, appConst.KAPPA);
colorMap.set(1, appConst.WHITE_FRAME);
colorMap.set(2, appConst.BLACK_FRAME);

export const materialMap = new Map();
materialMap.set(1, appConst.KAPPA);
materialMap.set(2, appConst.FRAME);

export const sizeMap = new Map();
sizeMap.set(0, appConst.SIZE_FRAME_200x200);
sizeMap.set(1, appConst.SIZE_FRAME_300x300);

// https://lupa-dev.atlassian.net/wiki/spaces/V3/pages/2233958418/objects+structures
export const bookFormatMap = new Map();
bookFormatMap.set(27, "200x200");
bookFormatMap.set(35, "300x300");
bookFormatMap.set(6, "217x280");
bookFormatMap.set(0, "195x270");
bookFormatMap.set(41, "360x290");
bookFormatMap.set(26, "297X210");
bookFormatMap.set(2, "195X145");
bookFormatMap.set(38, "140x140");

// https://lupa-dev.atlassian.net/wiki/spaces/V3/pages/2233958418/objects+structures
export const detailedBookFormatMap = new Map();
detailedBookFormatMap.set(
  27,
  appConst.SMALL_SQUARE + " " + appConst.SIZE_FRAME_200x200
);
detailedBookFormatMap.set(
  35,
  appConst.LARGE_SQUARE + " " + appConst.SIZE_FRAME_300x300
);
detailedBookFormatMap.set(
  6,
  appConst.CLASSIC_PLUS + " " + appConst.SIZE_FRAME_217x280
);
detailedBookFormatMap.set(
  0,
  appConst.CLASSIC + " " + appConst.SIZE_FRAME_195x270
);
detailedBookFormatMap.set(
  41,
  appConst.STUDIO + " " + appConst.SIZE_FRAME_360x290
);
detailedBookFormatMap.set(
  26,
  appConst.LARGE_PANORAMIC + " " + appConst.SIZE_FRAME_297X210
);
detailedBookFormatMap.set(
  2,
  appConst.SMALL_PANORAMIC + " " + appConst.SIZE_FRAME_195X145
);
detailedBookFormatMap.set(
  38,
  appConst.MINI_SQUARE + " " + appConst.SIZE_FRAME_140x140
);

// https://lupa-dev.atlassian.net/wiki/spaces/V3/pages/2233958418/objects+structures
export const bookFormatsOnlineMap = new Map();
bookFormatsOnlineMap.set(27, appConst.SMALL_SQUARE_WITH_CM);
bookFormatsOnlineMap.set(35, appConst.LARGE_SQUARE_WITH_CM);

// https://lupa-dev.atlassian.net/wiki/spaces/V3/pages/2233958418/objects+structures
export const bookFormatsAppMap = new Map();
bookFormatsAppMap.set(27, appConst.SMALL_SQUARE_WITH_CM);
bookFormatsAppMap.set(35, appConst.LARGE_SQUARE_WITH_CM);
bookFormatsAppMap.set(6, appConst.CLASSIC_PLUS_WITH_CM);
bookFormatsAppMap.set(26, appConst.LARGE_PANORAMIC_WITH_CM);
bookFormatsAppMap.set(38, appConst.MINI_SQUARE_WITH_CM);

// Full format labels for card display (with format name + dimensions)
export const bookFormatsFullMap = new Map();
bookFormatsFullMap.set(27, appConst.SMALL_SQUARE_FULL);
bookFormatsFullMap.set(35, appConst.LARGE_SQUARE_FULL);
bookFormatsFullMap.set(6, appConst.CLASSIC_PLUS_FULL);
bookFormatsFullMap.set(26, appConst.LARGE_PANORAMIC_FULL);
bookFormatsFullMap.set(38, appConst.MINI_SQUARE_FULL);

// https://lupa-dev.atlassian.net/wiki/spaces/V3/pages/2233958418/objects+structures
export const mockBookOnlineFormatMap = new Map();
mockBookOnlineFormatMap.set(27, "ריבועי קטן 20X20");
mockBookOnlineFormatMap.set(35, "ריבועי גדול 30X30");

// https://lupa-dev.atlassian.net/wiki/spaces/V3/pages/2233958418/objects+structures
export const mockBookAppFormatMap = new Map();
mockBookAppFormatMap.set(27, "ריבועי קטן 20X20");
mockBookAppFormatMap.set(38, "מיני לופה 10X10");

export const bookCoversMap = new Map();
bookCoversMap.set(0, appConst.HARD);
bookCoversMap.set(1, appConst.SOFT);
bookCoversMap.set(5, appConst.LAYFLAT);

// Full cover labels for card display (with "כריכה" prefix)
export const bookCoversFullMap = new Map();
bookCoversFullMap.set(0, appConst.HARD_COVER_FULL);
bookCoversFullMap.set(1, appConst.SOFT_COVER_FULL);
bookCoversFullMap.set(5, appConst.LAYFLAT_COVER_FULL);

export const calendarFormatMap = new Map();
// calendarFormatMap.set(92, "898x1264");
// calendarFormatMap.set(240, "1276x1789");
// calendarFormatMap.set(260, "1789x1276");
calendarFormatMap.set(92, "1264x898");
calendarFormatMap.set(240, "1789x1276");
calendarFormatMap.set(260, "1276x1789");

// Calendar format descriptions (used instead of legacy "skin" text)
export const calendarFormatDescriptionMap = new Map();
calendarFormatDescriptionMap.set(
  92,
  "לוח שנה שולחני בגודל A5"
);
calendarFormatDescriptionMap.set(
  240,
  "לוח שנה תלוי בגודל A4"
);
calendarFormatDescriptionMap.set(
  260,
  "לוח שנה תלוי בגודל A3"
);

export const headerTextMap = new Map();
headerTextMap.set(appConst.FIRST_PAGE, appConst.MARKETING_PAGE_TITLE);
headerTextMap.set(appConst.SECOND_PAGE, appConst.BASKET);
headerTextMap.set(appConst.FOURTH_PAGE, appConst.APPSALE);
headerTextMap.set(appConst.THIRD_PAGE, appConst.APPSALE);
headerTextMap.set(appConst.FIFTH_PAGE, appConst.DELIVERY_CHOICE);
headerTextMap.set(appConst.SIXTH_PAGE, appConst.DELIVERY_CHOICE);
headerTextMap.set(appConst.SEVENTH_PAGE, appConst.PERSONAL_INFO);
headerTextMap.set(appConst.EIGHTH_PAGE, appConst.ORDER_SUMMARY);
headerTextMap.set(appConst.NINTH_PAGE, appConst.PAYMENT);
headerTextMap.set(appConst.TENTH_PAGE, appConst.PAYMENT);
headerTextMap.set(appConst.ELEVNTH_PAGE, appConst.ORDER_COMPLETE);
headerTextMap.set(appConst.TWELTH_PAGE, appConst.ERROR_PAGE);
headerTextMap.set(appConst.THIRTEEN_PAGE, appConst.EMPTY_BASKET_PAGE_TITLE);

export const paymentTypsMap = new Map();
paymentTypsMap.set(0, appConst.UNDEFINED);
paymentTypsMap.set(1, appConst.ONLINE_CREDIT_CARD);
paymentTypsMap.set(2, appConst.SERVICE_CODE);
paymentTypsMap.set(3, appConst.POINTS);
paymentTypsMap.set(4, appConst.GIFT_CARD);
paymentTypsMap.set(5, appConst.ADMIN_CREDIT);
paymentTypsMap.set(6, appConst.COLLECTIVE_PRE_PAY);

export const lupaNativePageMap = new Map();
lupaNativePageMap.set(appConst.SECOND_PAGE, "basketItems");
lupaNativePageMap.set(appConst.FIFTH_PAGE, "delivery");
lupaNativePageMap.set(appConst.SEVENTH_PAGE, "personaldetails");
lupaNativePageMap.set(appConst.EIGHTH_PAGE, "summary");
lupaNativePageMap.set(appConst.NINTH_PAGE, "payment");
lupaNativePageMap.set(appConst.ELEVNTH_PAGE, "thanks");
lupaNativePageMap.set(appConst.TWELTH_PAGE, "error");
lupaNativePageMap.set(appConst.THIRTEEN_PAGE, "emptybasket");

export class AlbumOrder {
  constructor(
    event,
    page_type,
    customer_id,
    email,
    event_context,
    size,
    product_type,
    cart_id,
    is_business,
    is_send_to_someone_else,
    transaction_id,
    tax,
    value,
    shipping,
    coupon,
    currency,
    items
  ) {
    this.event = event;
    this.page_type = page_type;
    this.customer_id = customer_id;
    this.email = email;
    this.event_context = event_context;
    this.product_type = product_type;
    this.size = size;
    this.cart_id = cart_id;
    this.is_business = is_business;
    this.is_send_to_someone_else = is_send_to_someone_else;

    this.ecommerce = {
      transaction_id: transaction_id,
      tax: tax,
      value: value,
      shipping_tier: shipping,
      coupon: coupon,
      currency: currency,
      items: items,
    };
  }
}
